// 技巧视频/office基础课/技巧问答的过滤筛选项
const POST_ENUM = {
  'skill-video': 1, // 技巧视频
  'office-article': 2, // 文章
  'skill-qa': 5 // 技巧问答
};

const SORT_FILTER = [
  // 技巧视频/office基础课/视频类过滤条件
  { name: '最多播放', value: 'hot' },
  { name: '最新发布', value: 'newest' },
  { name: '最多收藏', value: 'fav' }
];

export {
  POST_ENUM,
  SORT_FILTER
};
